import CheckMark from '@/components/icons/checkMark'
import { Typography } from '@/components/ui/typography'
import testimonialHero from '@/assets/home/testimonial/hero.webp'
import testimonialEmoji from '@/assets/home/testimonial/emoji.webp'
import testimonialNotification from '@/assets/home/testimonial/notification.webp'

export function WhyTravelWithUs() {
  return (
    <div className="animate-scroll-down container grid grid-cols-1 items-center gap-8 lg:mb-20 lg:grid-cols-[1fr_1fr] lg:gap-16">
      <div className="space-y-6 md:space-y-8">
        <div className="space-y-2 md:space-y-4">
          <p className="text-red text-xl font-medium">Proč vyrazit s námi</p>
          <Typography variant="h2">
            S máte<span className="text-red">volno</span> strávíte méně času hledáním a více času v přírodě.
          </Typography>
        </div>
        <div className="space-y-6">
          <div className="animate-scroll-opacity flex gap-4">
            <div className="mt-1">
              <CheckMark />
            </div>
            <div className="space-y-1">
              <p className="text-lg leading-tight font-medium">Unikátní místa</p>
              <p className="text-sm text-slate-900/700">S námi se podíváte i na často vybookovaná místa.</p>
            </div>
          </div>

          <div className="animate-scroll-opacity flex gap-4">
            <div className="mt-1">
              <CheckMark />
            </div>
            <div className="space-y-1">
              <p className="text-lg leading-tight font-medium">Bezpečná platba</p>
              <p className="text-sm text-slate-900/700">
                Po zaplacení v platební bráně obdržíte e-mail s potvrzením a detaily
              </p>
            </div>
          </div>
          <div className="animate-scroll-opacity flex gap-4">
            <div className="mt-1">
              <CheckMark />
            </div>
            <div className="space-y-1">
              <p className="text-lg leading-tight font-medium">Jsme tu pro vás</p>
              <p className="text-sm text-slate-900/700">
                Všechny dotazy zodpovíme na zákaznické lince, volejte{' '}
                <a href="tel:+420605131713" className="text-red font-medium underline">
                  605&nbsp;131&nbsp;713
                </a>
                .
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="relative mx-auto max-w-100 scale-80 lg:scale-100">
        <img src={testimonialHero} alt="Proc vyrazit" />
        <img src={testimonialEmoji} alt="Proc vyrazit" className="absolute top-10 -left-15 h-30 w-30" />
        <img src={testimonialNotification} className="absolute -right-15 bottom-10 scale-90" alt="Proc vyrazit" />
      </div>
    </div>
  )
}
